var map = {
	"./wuyi_bg1.jpg": "3DMk",
	"./wuyi_bg2.jpg": "fmRS",
	"./wuyi_bg3.jpg": "q8/Y",
	"./wuyi_bg4.jpg": "n0az",
	"./wuyi_bg5.jpg": "Josp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "l4vG";